import { Portal } from '@shared/components';
import { PropsWithChildren } from 'react';

export const calculusActionPortalId = 'calculus-action-portal';

export function CalculusActionPortal({ children }: PropsWithChildren) {
  return <Portal elementId={calculusActionPortalId}>{children}</Portal>;
}
